import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';

import FilesField from './filesField';

const enhance = compose(
  withTranslation(['chat', 'common']),
);
export default enhance(FilesField);
